import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    strings: {
      startBtnText: "",
      firstSlideBtnText: "",
      lastSlideBtnText: "",
      lastSlideGhostText: "",
      soundPlayText: "",
      soundPauseText: "",
      mainPageTitle: "",
      mainPageSubtitle: "",
      mainPageGhostText: "",
      firstSlideText: "",
      lastSlideText: ""
    },
    currentPage: 1,
    currentStoryIndex: -1,
    dotActive: -1,
    currentCategory: null,
    isCategoryOpened: false,
    stories: [],
    categories: [],
    pages: [],
    orbitImages: [],
    windowWidth: 0,
    windowHeight: 0,
    navigationTheme: "",
    menuIsOpen: false,
    hideBurger: false,
    isMobile: false,
    menuCollapsed: false,
    headerWhite: true,
    headerHeight: 120,
    isMobileDevice: false,
    lightboxVisible: false,
    soundPlaying: false,
    autoplay: false,
    autoplayDelay: 0,
    autoplayTimeout: null,
    autoplayCurrentProgress: 0,
    orientation: 0,
    soundStart: true
  },
  actions: {

    async loadData({ commit, dispatch, state }) {
      let data = await axios.get("/wp-content/landing/data.json").then(({ data }) => data);

      commit('setCategories', data.categories);
      commit('setStories', data.stories);
      commit('setAutoplay', data.settings.autoplay);
      commit('setStrings', data.strings);
      commit('setAutoplayDelay', data.settings.autoplayDelay);
      state.stories.forEach((story, index) => {
        dispatch("loadStoryContent", index);
      });
    },

    loadStoryContent({ commit, state }, storyId) {
      axios.get(state.stories[storyId].contentFile).then((response) => {
        commit('updateStory', { id: storyId, content: response.data });
      });
    },

    changePage({ commit, state }, page) {
      if (page === state.currentPage) return;
      commit('setCurrentPage', page);
    },

    changeStory({ commit, state }, storyIndex) {
      if (state.currentStoryIndex == storyIndex) return;
      commit('setCurrentStoryIndex', false);
      commit('setDotActive', storyIndex);
      setTimeout(() => {
        commit('setCurrentStoryIndex', storyIndex);
        if (storyIndex === state.stories.length) {
          commit('setNavigationTheme', "blue");
        } else {
          commit('setNavigationTheme', "");
        }
      }, 1000);
    },

    changeCategory({ commit, state }, category) {
      if (category === state.currentCategory) return;
      state.currentCategory = null;
      setTimeout(() => {
        commit('setCurrentCategory', category);
      }, 300);
    },

    toggleCategoriesPopup({ commit }, open) {
      commit('setIsCategoryOpened', open);
    },

    startWithSound ({ commit }, prop) {
      commit('setStartWithSound', prop);
    },

    openCategory({ dispatch }, category) {
      dispatch('changeCategory', category);
      dispatch('toggleCategoriesPopup', true);
    },
    closeCategory({ dispatch }) {
      dispatch('changeCategory', null);
      dispatch('toggleCategoriesPopup', false);
    },
    toggleMenu({ commit, state }) {
      commit('setMenuIsOpen', !state.menuIsOpen);
    },
    checkMobile({ commit }) {
      commit('setMenuCollapsed', document.documentElement.offsetWidth <= 1024);
      commit('setIsMobile', document.documentElement.offsetWidth <= 768);
      commit('setWindowWidth', document.documentElement.offsetWidth);
      commit('setWindowHeight', window.innerHeight);
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        commit('setMobileDevice', true);
      } else if (navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform)) {
        commit('setMobileDevice', true);
      } else {
        commit('setMobileDevice', false);
      }
    },
    toggleLightbox({ commit, state }) {
      commit('setLightbox', !state.lightboxVisible);
    },
    toggleSound({ commit }, soundPlaying) {
      commit('setSoundPlaying', soundPlaying);
    },
    clearAutoplayTimeout({ state }) {
      clearTimeout(state.autoplayTimeout);
    }
  },

  getters: {
    currentStory(state) {
      return state.stories.length &&
        state.currentStoryIndex !== false &&
        state.currentStoryIndex !== -1 &&
        state.currentStoryIndex < state.stories.length
        ? state.stories[state.currentStoryIndex]
        : false;
    },
    isMobileView(state) {
      return state.isMobileDevice && state.isMobile && state.windowHeight > state.windowWidth;
    }
  },

  mutations: {
    setStartWithSound(state, payload) {
      state.soundStart = payload;
    },
    setCategories(state, payload) {
      state.categories = payload;
    },
    setStories(state, payload) {
      state.stories = payload;
    },
    updateStory(state, payload) {
      state.stories[payload.id].content = payload.content;
    },
    setOrbitImages(state, payload) {
      state.orbitImages = payload;
    },
    setCurrentPage(state, payload) {
      state.currentPage = payload;
    },
    setCurrentCategory(state, payload) {
      state.currentCategory = payload;
    },
    setIsCategoryOpened(state, payload) {
      state.isCategoryOpened = payload;
    },
    setCurrentStoryIndex(state, payload) {
      state.currentStoryIndex = payload;
    },
    setDotActive(state, payload) {
      state.dotActive = payload;
    },
    setWindowWidth(state, payload) {
      state.windowWidth = payload;
    },
    setWindowHeight(state, payload) {
      state.windowHeight = payload;
    },
    setNavigationTheme(state, payload) {
      state.navigationTheme = payload;
    },
    setMenuIsOpen(state, payload) {
      state.menuIsOpen = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setMenuCollapsed(state, payload) {
      state.headerHeight = payload ? 90 : 120;
      state.menuCollapsed = payload;
    },
    setMobileDevice(state, payload) {
      state.isMobileDevice = payload;
    },
    setLightbox(state, payload) {
      state.lightboxVisible = payload;
    },
    setSoundPlaying(state, payload) {
      state.soundPlaying = payload;
    },
    setAutoplayCurrentProgress(state, payload) {
      state.autoplayCurrentProgress = payload;
    },
    setAutoplay(state, payload) {
      state.autoplay = payload;
    },
    setAutoplayDelay(state, payload) {
      state.autoplayDelay = payload;
    },
    setAutoplayTimeout(state, payload) {
      state.autoplayTimeout = payload;
    },
    setHeaderWhite(state, payload) {
      state.headerWhite = payload;
    },
    setStrings(state, payload) {
      state.strings = payload;
    },
  },
});

export default store;